const SocialSharing = {
  install(Vue) {
    Vue.mixin({
      methods: {
        $getSocialSharingMetaInfo (data) {
          return [ ].concat(
            this.$getFacebookMetaInfo(data),
            this.$getTwitterMetaInfo(data),
          );
        },
        $getFacebookMetaInfo (data) {
          var meta = [];

          if (data.title) {
            meta.push({
              name: "og:title",
              content: data.title,
            });
          }

          if (data.description) {
            meta.push({
              name: "og:description",
              content: data.description,
            });
          }

          if (data.image) {
            meta.push({
              name: "og:image",
              content: data.image,
            });
          }

          if (meta.length > 0) {
            meta.push({
              name: "og:type",
              content: "website",
            });
          }

          return meta;
        },
        $getTwitterMetaInfo (data) {
          var meta = [];

          if (data.title) {
            meta.push({
              name: "twitter:title",
              content: data.title,
            });
          }

          if (data.description) {
            meta.push({
              name: "twitter:description",
              content: data.description,
            });
          }

          if (data.image) {
            meta.push({
              name: "twitter:image:src",
              content: data.image,
            });
          }

          if (meta.length > 0) {
            meta.push({
              name: "twitter:card",
              content: "summary",
            });
          }

          return meta;
        },
      },
    });
  },
};

export default SocialSharing;
